import React from 'react'
import "./linebreak.css"

const Linebreak = () => {
  return (
   <>
     <div className="linebreak">
          <img src="/Images/MyLineBreak.png" alt="Line Break" />
        </div>
   </>
  )
}

export default Linebreak
